import request from '../../axios';
import {IPostCheckStoreOrderOtpPayload} from './usePostCheckStoreOderOtp';

const postCheckStoreOderOtp = async (
  payload: IPostCheckStoreOrderOtpPayload,
) => {
  const data = await request.post(
    `/api/v2/payment/check-store-order-otp-code`,
    payload,
  );

  return data;
};

export default postCheckStoreOderOtp;
